import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  MotifTabNavigation,
  MotifTabControl,
  MotifModal,
} from '@ey-xd/motif-react';
import { Link } from 'react-router';
import { getFormValues, reset, change } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import * as masterDataManagementActions from '../../actions/masterDataManagementActions';
import * as reitActions from '../../actions/reitActions';
import * as lookupTypeActions from '../../actions/lookupTypeActions';
import MasterDataManagementPropertiesHeader from '../../components/masterDataManagement/MasterDataManagementPropertiesHeader';
import MasterDataManagementPropertyComponent from '../../components/masterDataManagement/MasterDataManagementPropertyComponent';
import AddEditPropertyModal from '../../components/masterDataManagement/AddEditPropertyModal';
import DeletePropertyMasterModal from '../../components/masterDataManagement/DeletePropertyMasterModal';
import EndPropertyModal from '../../components/reits/EndPropertyModal';
import UploadPropertiesModal from '../../components/masterDataManagement/UploadPropertiesModal';
import * as commonActions from '../../actions/commonActions';
import * as stringHelpers from '../../scripts/stringHelpers';
import ClearEndDateForm from '../../components/reits/ClearEndDateForm';
import * as Constants from '../../constants/other';
/**
 * MasterDataManagementPropertiesContainer component
 * @extends {React.Component}
 */
class MasterDataManagementPropertiesContainer extends React.Component {
  /**
   * Creates a new MasterDataManagementPropertiesContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.state = {
      gridCurrentState: [],
      gridColumnState: [],
      showAddEditPropertyModal: false,
      showDeletePropertyModal: false,
      selectedProperty: null,
      isEdit: false,
      validationMessage: '',
      errorMessage: '',
      activeReits: [],
      showEndForm: false,
      selectedPropertyForEnd: null,
      showClearEndForm: false,
      showUploadPropertiesModal: false,
      acquisitionValidationMessage: '',
    };

    // Bind methods
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
    this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
    this.handleDismissErrorMessage = this.handleDismissErrorMessage.bind(this);
    this.handleAddProperty = this.handleAddProperty.bind(this);
    this.handleExportPropertyImportTemplate =
      this.handleExportPropertyImportTemplate.bind(this);
    this.handleUploadPropertyImportTemplate =
      this.handleUploadPropertyImportTemplate.bind(this);
    this.handleDownloadMasterDataReport =
      this.handleDownloadMasterDataReport.bind(this);
    this.toggleAddEditPropertyModal =
      this.toggleAddEditPropertyModal.bind(this);
    this.toggleDeletePropertyModal = this.toggleDeletePropertyModal.bind(this);
    this.handleSaveProperty = this.handleSaveProperty.bind(this);
    this.handleConfirmDeleteProperty =
      this.handleConfirmDeleteProperty.bind(this);
    this.clearValidationMessage = this.clearValidationMessage.bind(this);
    this.refreshGrid = this.refreshGrid.bind(this);
    this.handleShowEndForm = this.handleShowEndForm.bind(this);
    this.handleCloseEndForm = this.handleCloseEndForm.bind(this);
    this.handleEndPropertySubmit = this.handleEndPropertySubmit.bind(this);
    this.handleShowClearEndForm = this.handleShowClearEndForm.bind(this);
    this.handleCloseClearEndForm = this.handleCloseClearEndForm.bind(this);
    this.handleClearEndPropertySubmit =
      this.handleClearEndPropertySubmit.bind(this);
    this.toggleUploadPropertiesModal =
      this.toggleUploadPropertiesModal.bind(this);
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    if (this.props.clientId) {
      // Fetch properties data
      this.props.masterDataManagementActions.fetchPropertyMasterData(
        this.props.clientId
      );
      this.props.reitActions.fetchReits(this.props.clientId, true);
      this.props.lookupTypeActions.fetchPropertyTypes();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.propertyMasterValues &&
      prevProps.propertyMasterValues &&
      prevProps.propertyMasterValues.propertyTypeID !==
        this.props.propertyMasterValues.propertyTypeID &&
      !['Mixed Use'].includes(
        this.props.lookupTypes.propertyTypes.find(
          (p) =>
            p.propertyTypeID == this.props.propertyMasterValues.propertyTypeID
        )?.propertyTypeDescription
      )
    ) {
      const newValue = this.props.lookupTypes.propertyTypes.find(
        (p) =>
          p.propertyTypeID == this.props.propertyMasterValues.propertyTypeID
      )?.propertyTypeDescription;
      const newFormValue =
        newValue !== 'Not Selected'
          ? [newValue?.replace('Multi-Family', 'MultiFamily')]
          : [];
      this.props.change(
        'addEditPropertyMasterForm',
        'psqPropertyTypes',
        newFormValue
      );
    }
  }

  componentWillUnmount() {
    this.props.masterDataManagementActions.clearPropertyMasterData();
    this.setState({ activeReits: [] });
  }

  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }

  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return { ...x };
      });
    this.setState({ gridCurrentState: rowData });
  }

  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  handleEditButtonClick(property) {
    this.setState({
      selectedProperty: property,
      showAddEditPropertyModal: true,
      isEdit: true,
      validationMessage: '',
      errorMessage: '',
      acquisitionValidationMessage: '',
      // filter active REITs and sort by alphabetical order
      activeReits: this.props.reits?.sort((a, b) => {
        return a.reitShortName.localeCompare(b.reitShortName);
      }),
    });
  }

  handleDeleteButtonClick(property) {
    this.setState({
      selectedProperty: property,
      showDeletePropertyModal: true,
    });
  }

  handleAddProperty() {
    const selectedProperty = {
      propertyTrackingID: stringHelpers.GetRandomX9Xxx9XxxString(6),
    };

    this.setState({
      selectedProperty: selectedProperty,
      showAddEditPropertyModal: true,
      isEdit: false,
      validationMessage: '',
      errorMessage: '',
      acquisitionValidationMessage: '',
      // filter active REITs and sort by alphabetical order
      activeReits: this.props.reits
        ?.filter((reit) => reit.isActive)
        .sort((a, b) => {
          return a.reitShortName.localeCompare(b.reitShortName);
        }),
    });
  }

  toggleAddEditPropertyModal() {
    this.setState({
      showAddEditPropertyModal: !this.state.showAddEditPropertyModal,
      validationMessage: '',
      errorMessage: '',
      acquisitionValidationMessage: '',
      selectedProperty: null,
    });
  }

  toggleDeletePropertyModal() {
    this.setState({
      showDeletePropertyModal: !this.state.showDeletePropertyModal,
      selectedProperty: null,
      validationMessage: '',
      errorMessage: '',
      acquisitionValidationMessage: '',
    });
  }

  clearValidationMessage() {
    if (this.state.validationMessage) {
      this.setState({ validationMessage: '' });
    }

    if (this.state.acquisitionValidationMessage) {
      this.setState({ acquisitionValidationMessage: '' });
    }
  }

  handleSaveProperty(values) {
    this.props.commonActions.beginTask();

    const propertyMaster = {
      clientID: this.props.clientId,
      propertyMasterID: values.propertyMasterID,
      reitId: values.reitid,
      propertyTrackingID: values.propertyTrackingID,
      gtpEntityID: values.gtpEntityID,
      clientEntityID: values.clientEntityID,
      propertyName: values.propertyName,
      propertyTypeID: values.propertyTypeID,
      psqPropertyTypes: values.psqPropertyTypes?.filter(
        (item) => item !== undefined
      ),
      street: values.street,
      city: values.city,
      state: values.state,
      zipCode: values.zipCode,
      rentableSquareFootage: values.rentableSquareFootage,
      purchasePrice: values.purchasePrice,
      acquisitionDate: values.acquisitionDate,
      endDate: values.endDate,
      propertyClassId: values.propertyClassID,
      tenantTypeId: values.tenantTypeID,
      propertyParkingTypeID: values.propertyParkingTypeID,
      managementCompany: values.managementCompany,
      managerName: values.managerName,
      managerEmail: values.managerEmail,
      managerPhone: values.managerPhone,
      accountantName: values.accountantName,
      accountantEmail: values.accountantEmail,
      accountantPhone: values.accountantPhone,
    };

    if (this.state.isEdit) {
      // Update existing property
      return this.props.masterDataManagementActions
        .updatePropertyMaster(propertyMaster)
        .then((response) => {
          if (response && response.success) {
            this.toggleAddEditPropertyModal();
            this.refreshGrid();
            this.props.commonActions.endTask();
          } else if (
            response &&
            response.response &&
            response.response.errorCode === 'BAD_REQUEST'
          ) {
            this.setState({ errorMessage: response.response.message });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            response.errorMessage ===
              'The given Property Name already exists for another property in the same REIT.'
          ) {
            this.setState({
              validationMessage: Constants.PROPERTY_NAME_EXISTS,
            });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            !response.success &&
            response.errorMessage?.toLowerCase().includes('acquisition date')
          ) {
            this.setState({
              acquisitionValidationMessage: response.errorMessage,
            });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            !response.success &&
            response.errorMessage != ''
          ) {
            // Handle other error messages
            this.setState({ errorMessage: response.errorMessage });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            response.response &&
            response.response.errorCode !== null
          ) {
            this.setState({ errorMessage: response.response.message });
            this.props.commonActions.endTask();
            return;
          }
        })
        .catch((error) => {
          this.props.commonActions.endTask();
          this.setState({
            errorMessage: 'An error occurred while updating the property.',
          });
        });
    } else {
      // Create new property
      return this.props.masterDataManagementActions
        .createPropertyMaster(propertyMaster)
        .then((response) => {
          if (response && response.success) {
            this.toggleAddEditPropertyModal();
            this.refreshGrid();
            this.props.commonActions.endTask();
          } else if (
            response &&
            response.response &&
            response.response.errorCode === 'BAD_REQUEST'
          ) {
            this.setState({ errorMessage: response.response.message });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            response.errorMessage ===
              'The given Property Name already exists for another property in the same REIT.'
          ) {
            this.setState({
              validationMessage: Constants.PROPERTY_NAME_EXISTS,
            });
            this.props.commonActions.endTask();
            return;
          } else if (
            response &&
            !response.success &&
            response.errorMessage != ''
          ) {
            this.setState({ errorMessage: response.errorMessage });
            this.props.commonActions.endTask();
            return;
          }
        })
        .catch(() => {
          this.setState({
            errorMessage: 'An error occurred while creating the property.',
          });
          this.props.commonActions.endTask();
        });
    }
  }

  handleConfirmDeleteProperty(property) {
    if (property && property.propertyMasterID && property.reitid) {
      this.props.commonActions.beginTask();
      this.props.masterDataManagementActions
        .deletePropertyMaster(
          this.props.clientId,
          property.reitid,
          property.propertyMasterID
        )
        .then((response) => {
          if (response && !response.success && response.errorMessage != '') {
            this.setState({ errorMessage: response.errorMessage });
            this.props.commonActions.endTask();
            return;
          } else if (response && response.success) {
            this.toggleDeletePropertyModal();
            this.refreshGrid();
            this.props.commonActions.endTask();
          }
        })
        .catch(() => {
          this.setState({
            errorMessage: 'An error occurred while deleting the property.',
          });
          this.props.commonActions.endTask();
        });
    }
  }

  refreshGrid() {
    this.props.masterDataManagementActions.fetchPropertyMasterData(
      this.props.clientId
    );
  }

  handleExportPropertyImportTemplate() {
    this.props.masterDataManagementActions.exportPropertiesData(
      this.props.clientId
    );
  }

  handleUploadPropertyImportTemplate() {
    this.setState({ showUploadPropertiesModal: true });
  }

  toggleUploadPropertiesModal(clientID) {
    this.setState({
      showUploadPropertiesModal: !this.state.showUploadPropertiesModal,
    });
    if (clientID && clientID === this.props.clientId) {
      this.props.masterDataManagementActions.fetchPropertyMasterData(clientID);
    }
  }

  handleDownloadMasterDataReport() {
    this.props.masterDataManagementActions.exportAllTypesData(
      this.props.clientId
    );
  }

  handleDismissErrorMessage() {
    this.props.commonActions.clearFormErrors('addEditPropertyMasterForm');
  }

  handleShowEndForm(propertyMasterID) {
    this.setState({
      selectedPropertyForEnd: this.props.propertyMasterData?.find(
        (p) => p.propertyMasterID === propertyMasterID
      ),
      showAddEditPropertyModal: false,
      showEndForm: true,
    });
  }

  handleCloseEndForm() {
    this.setState({
      showEndForm: false,
      selectedPropertyForEnd: null,
    });
  }

  handleEndPropertySubmit(values) {
    if (values && values.endDate && this.state.selectedPropertyForEnd) {
      const reitID = this.state.selectedPropertyForEnd.reitid;
      const propertyMasterID =
        this.state.selectedPropertyForEnd.propertyMasterID;
      const endDate = values.endDate;
      const clientID = this.props.clientId;

      this.props.masterDataManagementActions
        .endProperty(reitID, propertyMasterID, endDate, clientID)
        .then((response) => {
          if (response && response.success) {
            this.handleCloseEndForm();
            this.refreshGrid();
          } else if (
            response &&
            !response.success &&
            response.response &&
            response.response.errorMessage
          ) {
            this.setState({ errorMessage: response.response.errorMessage });
            return;
          }
        })
        .catch((error) => {
          this.setState({
            errorMessage: 'An error occurred while ending the property.',
          });
        });
    }
  }

  handleShowClearEndForm(propertyMasterID) {
    this.setState({
      selectedPropertyForEnd: this.props.propertyMasterData?.find(
        (p) => p.propertyMasterID === propertyMasterID
      ),
      showAddEditPropertyModal: false,
      showClearEndForm: true,
    });
  }

  handleCloseClearEndForm() {
    this.setState({
      showClearEndForm: false,
      selectedPropertyForEnd: null,
    });
  }

  handleClearEndPropertySubmit() {
    this.props.masterDataManagementActions
      .clearPropertyMasterEndDate(
        this.props.clientId,
        this.state.selectedPropertyForEnd.propertyMasterID,
        this.state.selectedPropertyForEnd.reitid
      )
      .then((response) => {
        if (response && !response.success && response.errorMessage != '') {
          this.setState({ errorMessage: response.errorMessage });
          return;
        } else if (response && response.success) {
          this.handleCloseClearEndForm();
          this.refreshGrid();
        }
      })
      .catch(() => {
        this.setState({
          errorMessage:
            'An error occurred while clearing the property end date.',
        });
      });
  }

  render() {
    return (
      <div>
        <h2 data-testid="pghdrMasterDataManagement">Master Data Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/groups`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(1)}
              data-testid="tbGroups"
            >
              Groups
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/reits`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(2)}
              data-testid="tbREITs"
            >
              REITs
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/properties`}
            tabIndex="-1"
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              onClick={() => this.handleTabClick(3)}
              data-testid="tbProperties"
            >
              Properties
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/securities`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(4)}
              data-testid="tbSecurities"
            >
              Securities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/trs`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(5)}
              data-testid="tbTrs"
            >
              Taxable REIT Subsidiaries
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>

        <MasterDataManagementPropertiesHeader
          handleAddProperty={this.handleAddProperty}
          handleExportPropertyImportTemplate={
            this.handleExportPropertyImportTemplate
          }
          handleUploadPropertyImportTemplate={
            this.handleUploadPropertyImportTemplate
          }
          handleDownloadMasterDataReport={this.handleDownloadMasterDataReport}
        />

        <MasterDataManagementPropertyComponent
          propertiesData={this.props.propertyMasterData || []}
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.state.gridColumnState}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          handleEditButtonClick={this.handleEditButtonClick}
          handleDeleteButtonClick={this.handleDeleteButtonClick}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
        />

        <AddEditPropertyModal
          show={this.state.showAddEditPropertyModal}
          onClose={this.toggleAddEditPropertyModal}
          reits={this.state.activeReits}
          lookupTypes={this.props.lookupTypes}
          onSave={this.handleSaveProperty}
          initialValues={this.state.selectedProperty}
          isEdit={this.state.isEdit}
          validationMessage={this.state.validationMessage}
          errorMessage={this.state.errorMessage}
          clearValidationMessage={this.clearValidationMessage}
          handleShowEndForm={this.handleShowEndForm}
          handleShowClearEndForm={this.handleShowClearEndForm}
          acquisitionValidationMessage={this.state.acquisitionValidationMessage}
        />

        <DeletePropertyMasterModal
          show={this.state.showDeletePropertyModal}
          onClose={this.toggleDeletePropertyModal}
          initialValues={this.state.selectedProperty}
          onConfirmDelete={this.handleConfirmDeleteProperty}
          errorMessage={this.state.errorMessage}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
        />

        {this.state.showUploadPropertiesModal && (
          <UploadPropertiesModal
            show={this.state.showUploadPropertiesModal}
            onClose={this.toggleUploadPropertiesModal}
          />
        )}

        <MotifModal
          show={this.state.showEndForm && this.state.selectedPropertyForEnd}
          aria-label="End Property"
          size="md"
          variant="alt"
          onClose={this.handleCloseEndForm}
        >
          {this.state.selectedPropertyForEnd && (
            <EndPropertyModal
              onSave={this.handleEndPropertySubmit}
              initialValues={this.state.selectedPropertyForEnd}
              handleDismissErrorMessage={this.handleDismissErrorMessage}
              handleCloseEndForm={this.handleCloseEndForm}
              errorMessage={this.state.errorMessage}
            />
          )}
        </MotifModal>

        <MotifModal
          show={
            this.state.showClearEndForm && this.state.selectedPropertyForEnd
          }
          aria-label="Clear End Date"
          size="md"
          variant="alt"
          onClose={this.handleCloseClearEndForm}
        >
          {this.state.selectedPropertyForEnd && (
            <ClearEndDateForm
              handleSubmit={this.handleClearEndPropertySubmit}
              initialValues={this.state.selectedPropertyForEnd}
              handleDismissErrorMessage={this.handleDismissErrorMessage}
              handleCloseForm={this.handleCloseClearEndForm}
            />
          )}
        </MotifModal>
      </div>
    );
  }
}

MasterDataManagementPropertiesContainer.propTypes = {
  clientId: PropTypes.number,
  isAudit: PropTypes.bool,
  reits: PropTypes.array,
  lookupTypes: PropTypes.array,
  propertyMasterData: PropTypes.array,
  commonActions: PropTypes.object,
  masterDataManagementActions: PropTypes.object.isRequired,
  reitActions: PropTypes.object.isRequired,
  lookupTypeActions: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  propertyMasterValues: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    isAudit: state.client && state.client.isAudit,
    propertyMasterData: state.propertyMasterData || [],
    reits: state.reits || [],
    lookupTypes: (state.lookupTypes && state.lookupTypes) || [],
    propertyMasterValues: getFormValues('addEditPropertyMasterForm')(state),
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    masterDataManagementActions: bindActionCreators(
      masterDataManagementActions,
      dispatch
    ),
    reitActions: bindActionCreators(reitActions, dispatch),
    lookupTypeActions: bindActionCreators(lookupTypeActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    change: bindActionCreators(change, dispatch),
    reset: bindActionCreators(reset, dispatch), // Add reset to the bound actions
    dispatch, // Include the raw dispatch function if needed elsewhere
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MasterDataManagementPropertiesContainer)
);
